export interface Language {
  code: string;
  language: string;
}

export const ENGLISH: Language = {
  code: 'en',
  language: 'English',
};
